"use client"; 
import Logo from "../../../components/ui/logo";
import Image from "next/image";
import FooterIllustration from "@/public/images/footer-illustration.svg";
import { useEffect, useState } from "react";
import Link from "next/link";
import Footer from "@/components/ui/footer";


const metadata = {
  title: "Sign In - Open PRO",
  description: "Page description",
};

export default function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState(""); 
 
  let customerId=""

const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL;
console.log("✅ Loaded API_BASE_URL:", API_BASE_URL);

  const handleSubmit = async (e: any) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setSuccessMessage("");
  
    try {
      const response = await fetch(`${API_BASE_URL}/signin`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          workEmail: email,
          password: password,
        }),
      });
  
      const data = await response.json();
      console.log(response.status);
      
       if (!response.ok) {
        switch (response.status) {
        case 404:
          setError("Adresse email n'existe pas");
          break;
        case 401:
          setError("Mot de passe incorrect");
          break;
        case 403:
          setError(data.message || "Compte non vérifié");
          break;
        default:
          setError(data.message || "Une erreur est survenue");
      }
     } else {
        const token = data.token;
        
        if (token) {
          localStorage.setItem('token', token);
          console.log(token);
          const profileResponse = await fetch(`${API_BASE_URL}/profile`, {
            method: "GET",
            headers: {
              "Authorization": `Bearer ${token}`,  
            },
          });

          const profileData = await profileResponse.json();
          customerId=profileData._id;
          localStorage.setItem('customerId', customerId);
          console.log("ud",customerId);
          
          if (!profileResponse.ok) {
            setError(profileData.message || "Error fetching profile");
          } else {
            console.log("User profile fetched:", profileData);
            if (email === "admin@admin.com" || email ==="amine.mhedhbi@cweave.fr") {
              window.location.href = "/orders";
            } else {
              window.location.href = "/bookOrder";
            }
          }
        }
        setSuccessMessage("Connexion réussie !");
        console.log("Sign in successful:", data);
      }
    } catch (err) {
      setError("Erreur serveur, veuillez réessayer.");
      console.log(err);

    } finally {
      setLoading(false);
    }
  };

  return (
<div className="h-screen">
   <section>
      <div className="mx-auto max-w-6xl px-4 sm:px-6">
        <div className="py-8 md:py-17">
          {/* Section header */}
          <div className="pb-12 text-center">
            <h1  className="animate-[gradient_6s_linear_infinite] bg-[linear-gradient(to_right,theme(colors.gray.400),theme(colors.blue.500),theme(colors.gray.600),theme(colors.blue.600),theme(colors.gray.400))] bg-[length:200%_auto] bg-clip-text pb-5 font-nacelle text-4xl font-semibold text-transparent md:text-4xl">
            Bienvenue à nouveau
            </h1>
          </div>
          {/* Contact form */}
          <form className="mx-auto max-w-[400px] shadow-lg rounded-lg p-4" onSubmit={handleSubmit}>
          <div className="space-y-5">
              <div>
                <label
                  className="mb-1 block text-sm font-medium text-blue-900"
                  htmlFor="email"
                >
                  Email  <span className="text-red-500">*</span>
                </label>
                <input
                  id="email"
                  type="email"
                  className="form-input w-full bg-white text-black"
                  placeholder="Votre email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <div>
                <div className="mb-1 flex items-center justify-between gap-3">
                  <label
                    className="block text-sm font-medium text-blue-900"
                    htmlFor="password"
                  >
                Mot de passe   <span className="text-red-500">*</span>
                  </label>

                </div>
                <input
                  id="password"
                  type="password"
                  className="form-input w-full bg-white text-black"
                  placeholder="Votre mot de passe"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
            </div>
            <div className="mt-6 space-y-5">
              <button
                type="submit"
                className="btn w-full bg-gradient-to-t  bg-[rgb(82,146,158)] bg-[length:100%_100%] bg-[bottom] text-white shadow-[inset_0px_1px_0px_0px_theme(colors.white/.16)] hover:bg-[length:100%_150%]"
                disabled={loading}
              >
                {loading ? "Connexion en cours..." : "Se connecter"}
              </button>
              {error && (
                <div className="text-center text-sm text-red-500 mt-2">{error}</div>
              )}
              {successMessage && (
  <div className="text-center text-sm text-teal-600 rounded-lg p-2 mt-2">
  {successMessage}
</div>)}

            </div>
          </form>
          <div className="mt-6 text-center text-sm text-blue-900">
          Vous n'avez pas de compte ?{" "}
          <Link className="font-medium text-teal-500" href="/signup">
          S'inscrire
          </Link>
          </div>
          <div className="mt-6 text-center text-sm text-blue-900">
          Vous oubliez votre mot de passe ?{" "}
          <Link className="font-medium text-teal-500" href="/forgot-password">
          Oubliez Mot de passe
          </Link>
          </div>
        </div>
      </div>
      
    </section>
      <Footer/>
</div> 
 );
}
